import type React from 'react';
import SaisieLibreComponent from '../../../../components/Mouvement/Panel/InformationsRattachement/SaisieLibreComponent';
import type PanelComponentProps from '../../../../interfaces/pieces/mouvements/panelComponentProps';
import InformationsRattachementPanel from '../InformationsRattachementPanel';

class SaisieLibrePanel extends InformationsRattachementPanel {
	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<SaisieLibreComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default SaisieLibrePanel;
